import React from 'react';
import getDealerPageProps, { PAGE_TYPES } from 'shared/routes/dealer';
import { DEALER_TABS } from 'shared/constants/navigation';
import Dealer from '../Dealer';
import Layout from '../../../components/Layout';
import LINKS from '../../../constants/navigation';

async function action(params) {
  const pageProps = await getDealerPageProps(params, PAGE_TYPES.ABOUT);

  if (!pageProps) {
    return null;
  }

  const {
    url,
    query,
    news,
    transportType,
    dealer,
    carsListTypes,
    dealersTypes,
    title,
    description,
  } = pageProps;

  return {
    chunks: ['dealer'],
    title,
    description,
    component: (
      <Layout navLinks={LINKS.SEARCH.avto} currentRoute={url}>
        <Dealer
          transportType={transportType}
          dealerInfo={dealer}
          tab={DEALER_TABS.ABOUT}
          carsListTypes={carsListTypes}
          currentNewsId={news}
          dealersTypes={dealersTypes}
          url={url}
          query={query}
        />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/desktop/routes/dealer/about/index.js